import styles from "./CustomFileInput.module.css"

interface CustomFileInputProps {
    handleFileChange: (file: File | undefined) => void
    disabled?: boolean
    className?: string
}

export const CustomFileInput = ({
    handleFileChange,
    disabled = false,
}: CustomFileInputProps) => {
    return (
        <label>
            <div className={styles["custom-file-input"]}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="none"
                    viewBox="0 0 16 16"
                >
                    <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m1.5 10.5 3.44-3.44a1.5 1.5 0 0 1 2.12 0l3.44 3.44m-1-1 .94-.94a1.5 1.5 0 0 1 2.12 0l1.94 1.94M2.5 13h11a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-11a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1Zm7-7.5h.005v.005H9.5V5.5Zm.25 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
                    />
                </svg>
                Upload Image / Video
            </div>
            <input
                type="file"
                accept="image/*, video/*"
                onChange={(e) => handleFileChange(e.target.files?.[0])}
                disabled={disabled}
                className={styles["file-input"]}
            />
        </label>
    )
}
